import { MessageEventSetItem } from '@tt4b/ttam-enums';
import { computed, Ref, ref } from '@vue/composition-api';
import { filterKeywords } from './../../../utils/string-utils';

/**
 * 展示的 messageEventSetList
 * 过滤并进行按照关键字进行分组
 * @param list messageEventSet 列表
 * @returns
 */
export function useMessageEventSetDisplayList(list: Ref<MessageEventSetItem[]>) {
  const keywords = ref('');
  const filterList = computed(() => {
    const arr = list?.value.filter(({ name, id }) => filterKeywords(`${name}${id}`, keywords.value)) || [];
    return arr;
  });
  return {
    keywords,
    filterList,
  };
}
